export enum LangEnum
{
    Polish = 1,
    English = 2,
    German = 3,
    Slovak = 4,
    Estonian = 5,
    Czech = 6,
    Lithuanian = 7
}